import { fontWeight } from "html2canvas/dist/types/css/property-descriptors/font-weight";
import { Cell } from "recharts";

export const mockEmailTemplates = [
  {
    id: "promo-1",
    name: "Data Design Promotion",
    design: {
      body: {
        id: "body_promo",
        values: {
          backgroundColor: "#f3f6fb",
          contentWidth: "600px"
        },
        rows: [
          {
            id: "row_header",
            cells: [1],
            values: {
              padding: "30px",
              backgroundColor: "#ffffff"
            },
            columns: [
              {
                id: "col_header",
                values: {
                  padding: "10px"
                },
                contents: [
                  {
                    id: "content_logo",
                    type: "text",
                    values: {
                      text: "<h1 style='color:#2563eb'>Data Design Academy</h1>",
                      textAlign: "center",
                      fontWeight:"700"
                    }
                  }
                ]
              }
            ]
          },

          {
            id: "row_body",
            cells: [1],
            values: {
              padding: "20px",
              backgroundColor: "#ffffff"
            },
            columns: [
              {
                id: "col_body",
                values: {
                  padding: "10px"
                },
                contents: [
                  {
                    id: "content_greeting",
                    type: "text",
                    values: {
                      text: "<p>Hello <strong>{{name}}</strong>,</p><p>We are excited to invite you from <strong>{{institute}}</strong> to our exclusive <b>Data Design Promotion Program</b>.</p>",
                      fontSize: "14px"
                    }
                  },
                  {
                    id: "content_list",
                    type: "text",
                    values: {
                      text: "<ul><li>Industry-ready curriculum</li><li>Live mentor support</li><li>Hands-on projects</li><li>Certification</li></ul>"
                    }
                  }
                ]
              }
            ]
          },

          {
            id: "row_cta",
            cells: [1],
            values: {
              padding: "20px",
              backgroundColor: "#ffffff"
            },
            columns: [
              {
                id: "col_cta",
                values: {
                  padding: "10px"
                },
                contents: [
                  {
                    id: "content_cta",
                    type: "button",
                    values: {
                      text: "Join Now",
                      link: {
                        href: "https://example.com/register",
                        target: "_blank"
                      },
                      backgroundColor: "#2563eb",
                      color: "#ffffff",
                      borderRadius: "6px",
                      textAlign: "center"
                    }
                  }
                ]
              }
            ]
          },

          {
            id: "row_footer",
            cells: [1],
            values: {
              padding: "20px",
              backgroundColor: "#f9fafb"
            },
            columns: [
              {
                id: "col_footer",
                values: {
                  padding: "10px"
                },
                contents: [
                  {
                    id: "content_footer",
                    type: "text",
                    values: {
                      text: "<p style='font-size:12px;color:#6b7280'>This invitation was sent to {{email}}<br/>© 2025 Data Design Academy</p>",
                      textAlign: "center"
                    }
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
];


